import axios from 'axios'
import router from '../router/index'
import Cookies from 'js-cookie'
import baseUrl from "../assets/js/baseUrl"
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.baseURL = `${baseUrl}api`;


// http请求拦截器
let toast;
axios.interceptors.request.use(config => {
    const token = Cookies.get("token") ? Cookies.get("token") : "";
    if (token) {
        config.headers.Authorization = `Bearer ${ token }`;
    }
    return config;
}, error => {
    router.push({path: "/NotFound"});
    return Promise.reject(error);
})
// http响应拦截器
axios.interceptors.response.use(data => {// 响应成功关闭loading
    return data;
}, error => {
    if (error.response) {
        switch (error.response.status) {//401的时候，如果是公众号跳登录，企业号、app给提示
            // case 400:
            //     Message.error({
            //         message:"账号/密码错误",
            //         type:"error",
            //         duration:2000
            //     })
            case 401://没有权限
                router.replace(
                    {path: "/Login",query: {redicet: router.currentRoute.fullPath}}
                );
                break;
            case 403:
                router.push({path: "/NotFound4"});
                break;
            case 404:
                router.push({path: "/NotFound4"});
                break;
            case 500:
                router.push({path: "/NotFound5"});
                break;
            case 502:
                router.push({path: "/NotFound5"});
                break;
            case 503:
                router.push({path: "/NotFound5"});
                break;
        }
    } else {
        router.push({path: "/NotFound"});
    }
    return Promise.reject(error);
})
 
export default axios;


// WEBPACK FOOTER //
// ./src/http/http.js